/**
 * Shopify-style Experience View for Item Group DocType
 *
 * Relies on DocViewSchema for layout — formView is undefined.
 */

import type { DocTypeView } from '../types';

export const itemGroupShopifyView: DocTypeView = {
  id: 'item-group-shopify-v1',
  doctype: 'Item Group',
  style: 'shopify',
  context: undefined,
  status: 'active',
  label: 'Item Group – Shopify Style',
  description: 'Shopify-style layout for Item Group detail page',
  formView: undefined,
  createdBy: 'system',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};
